export default __webpack_public_path__ + "static/media/resume.ed215493.pdf";